module.exports = __webpack_public_path__ + "img/u230821.cedb42cc.png";